<script>
//FacetFilter.vue

import SingleList from "./SingleList"
import ToggleButton from "./ToggleButton";
import DateRange from "./DateRange";
import SimpleText from "./SimpleText";

export default {
    components: {
        SingleList,
        ToggleButton,
        DateRange,
        SimpleText
    },
    props: {
        headline: String,
        facets: Object,
        orderByOptions: Array,
        filter: Object,
        aggregations: Object,

    },
    data() {
        return {
            baseUrl: Scoop.baseUrl,
            loading: false,
            selectedMedia: false,
        }
    },
    computed: {
        clearedFilter() {
            return _.pickBy(_.pickBy(this.filter, value => value !== null), value => value !== []);  // Remove null values
        },
        activeFilters() {
            return Object.keys(this.filter).map((key) => [(key), this.filter[key]]);
        }
    },
    watch: {
        selectedMedia(value) {
            // this.searchAgain();
        },
        filter(value) {
            if (value.response) { // If filter changed because of response from server
                return;
            }
            this.searchAgain();
        }
    },

    methods: {
        closeAll() {
            scoopOS.$emit("closeAllFacetGroups");
        },
        expandAll() {
            scoopOS.$emit("expandAllFacetGroups");
        },
        filterChanged(facet, newValue) {
            this.$emit('filter-changed', facet, newValue);
        },
        facetClass(group) {
            return group ? "media-facet-group" : "media-facet";
        },
        searchAgain() {
            this.performSearch(this);
        },
        performSearch: _.debounce((vm) => {
            console.log('performSearch: ', vm.clearedFilter);
            window.history.pushState({}, document.title, vm.baseUrl + '/mediaserver/media');

            vm.loading = true;
            axios
                .post(vm.baseUrl + '/mediaserver/media', {'filter': vm.clearedFilter})
                .then(response => {
                    vm.$emit('newsearchresult', response.data.pagedItems, response.data.filter, response.data.aggregations);
                })
                .catch(error => {
                    console.log('error', error)
                    vm.errored = true
                })
                .finally(() => vm.loading = false);
        }, 1000),

        resetFilter() {
            this.$emit('reset');
        }
    },
}
</script>

<template>
    <div>
        <div class="ibox float-e-margins mediafilter">

            <div class="ibox-title">
                <h5>Filter</h5>
                <div class="ibox-tools">
                    <!--                    <tooltip text="hide all filters" position="left">-->
                    <!--                        <a class="btn btn-default btn-xs" @click="closeAll">-->
                    <!--                            <i class="fa fa-angle-up"></i>-->
                    <!--                        </a>-->
                    <!--                    </tooltip>-->
                    <!--                    <tooltip text="show all filters" position="left">-->
                    <!--                        <a class="btn btn-default btn-xs" @click="expandAll">-->
                    <!--                            <i class="fa fa-angle-down"></i>-->
                    <!--                        </a>-->
                    <!--                    </tooltip>-->
                    &nbsp;
                    <tooltip text="reset all filters" position="left">
                        <a class="erase" @click="resetFilter">
                            <i class="fa fa-eraser"></i>
                        </a>
                    </tooltip>
                    <!--                    <a class="collapse-link">-->
                    <!--                        <i class="fa fa-chevron-up"></i>-->
                    <!--                    </a>-->
                </div>
            </div>

            <div class="ibox-content">
                <!--
                <div v-if="activeFilters" class="active-filters">
                    Active Filters:<br>
                    <div v-for="(item, index) in activeFilters">
                        {{item}}
                    </div>
                </div>
                -->
                <div class="file-manager">
                    <div class="row">

                        <slot name="facetfilter"
                              :facets="facets"
                              :filter="filter"
                              :aggregations="aggregations"
                              :events="{ searchAgain, resetFilter, filterChanged }"
                        >
                        </slot>

                    </div>

                    <slot></slot>

                </div>
            </div>

        </div>

    </div>
</template>

<style>

.active-filters {
    margin-top: 8px;
}

.ibox-content {
    background-color: #fcfcfc;
    padding: 15px 5px 0 5px;
}

.ds-hover-custom {

}

.ds-selected-custom {
}

.ds-selector-custom {
    border: 2px dotted #a39577 !important;
    background-color: rgba(163, 149, 119, 0.3) !important;
    display: none;
}

.ibox-content {
    background-color: #fcfcfc;
}

.ibox.facet-group {
    border: none !important;
    margin-bottom: 0px;
    border-top: none;
}

.ibox.facet-group .ibox-title h5 {
    color: #777777;
    font-weight: 700;
    font-style: italic;
    text-transform: none;
    font-smooth: always;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

.ibox.facet-group .ibox-content {
    padding: 5px;
}

.media-facets {
    padding: 4px !important;
}

.media-facets > .media-facet-group {
    background-color: white;
    padding: 8px;
    margin-top: 12px;
    border-top: 1px solid rgba(163, 149, 119, 0.5);
    border-left: 1px solid rgba(163, 149, 119, 0.5);
}

.media-facets > .media-facet-group ~ .media-facet-group {
    border-top: none;
    margin-top: 0px;
}

.media-facet {
    background-color: white;
    /*  margin-top: 12px;
      padding: 8px;*/
    border-top: 1px solid rgba(163, 149, 119, 0.5);
    border-left: 1px solid rgba(163, 149, 119, 0.5);
    -webkit-box-shadow: 8px 8px 8px -13px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 8px 8px 8px -13px rgba(0, 0, 0, 0.75);
    box-shadow: 8px 8px 8px -13px rgba(0, 0, 0, 0.75);
}

.filters-container {
    display: block;
    margin-top: 16px;
}
</style>
